import {
  BaseEditorState,
  Exchange,
  ExchangeChannel,
  TradingPair
} from "./common.types"

const allFuturesIntervals = ["quarterly", "biquarterly", "perpetual"] as const

export type FuturesInterval = typeof allFuturesIntervals[number] | never

export const FuturesInterval = {
  /** List of all intervals */
  all: allFuturesIntervals,
  /** Type guard for checking if something is a futures interval */
  isFuturesInterval: (interval: unknown): interval is FuturesInterval =>
    allFuturesIntervals.includes(interval as FuturesInterval)
}

export interface FuturesEditorState extends BaseEditorState<"futures"> {
  event: "subscribe"
  interval: FuturesInterval
  channel: ExchangeChannel
  symbol: TradingPair
  exchange: Exchange
  duration: number
  refundInvoice: string
}

/** Given an invoice, returns the default editor state for each channel */
export const DefaultFuturesRequestsForChannel: (
  refundInvoice: string
) => {
  [channel in ExchangeChannel]: FuturesEditorState
} = refundInvoice => ({
  books: {
    api: "futures",
    event: "subscribe",
    interval: "biquarterly",
    channel: "books",
    symbol: "BTCUSD",
    exchange: "bitmex",
    duration: 120000,
    refundInvoice
  },
  tickers: {
    api: "futures",
    event: "subscribe",
    interval: "perpetual",
    channel: "tickers",
    symbol: "ETHUSD",
    exchange: "bitmex",
    duration: 120000,
    refundInvoice
  },
  trades: {
    api: "futures",
    event: "subscribe",
    interval: "quarterly",
    channel: "trades",
    symbol: "ETHBTC",
    exchange: "bitmex",
    duration: 120000,
    refundInvoice
  }
})
